import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TowelsIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TowelsIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.8643 3.23143C21.5407 3.23143 21.2784 3.49377 21.2784 3.81737V5.57519H20.0674V4.59863C20.0674 3.41398 19.1036 2.45019 17.919 2.45019H6.98146C5.79681 2.45019 4.83302 3.41398 4.83302 4.59863V5.57519H3.62208V3.81737C3.62208 3.49378 3.35974 3.23143 3.03614 3.23143C2.71254 3.23143 2.4502 3.49377 2.4502 3.81737V6.16112C2.4502 6.48471 2.71254 6.74706 3.03614 6.74706H4.83302V17.958C4.83302 18.2816 5.09536 18.5439 5.41896 18.5439H7.95803V21.8643C7.95803 22.1879 8.22037 22.4502 8.54397 22.4502H19.4815C19.8051 22.4502 20.0674 22.1879 20.0674 21.8643V6.74706H21.8643C22.1879 6.74706 22.4502 6.48472 22.4502 6.16112V3.81737C22.4502 3.49378 22.1879 3.23143 21.8643 3.23143ZM9.12991 17.7627H18.8955V18.9346H9.12991V17.7627ZM17.919 3.62205C18.4575 3.62205 18.8955 4.06014 18.8955 4.59861V16.5908H9.1299V4.59862C9.1299 4.25053 9.04615 3.92182 8.89857 3.63069C8.89716 3.62784 8.8963 3.62491 8.89486 3.62206L17.919 3.62205ZM6.0049 4.59861C6.0049 4.06013 6.44299 3.62205 6.98146 3.62205C7.51993 3.62205 7.95802 4.06014 7.95802 4.59861V5.57517H6.00489L6.0049 4.59861ZM6.0049 17.3721V6.74706H7.95803V17.3721L6.0049 17.3721ZM18.8955 21.2783H9.12991V20.1064H18.8955V21.2783Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TowelsIcon;
